import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { RutterJobStatus } from './rutter-job.status';

export const RutterJobSchema = WithBaseEntitySchema(
    z.object({
        entityId: z.string(),
        entityType: z.string(),
        jobId: z.string().optional(),
        status: EnumSchema(RutterJobStatus),
        method: z.string().optional(),
        providerId: z.string().optional(),
        payload: z.record(z.any()).optional().nullish(),
    }),
).strict();

export class RutterJob extends FromSchema(RutterJobSchema) implements BaseEntity {
    id: string;
    entityId: string;
    entityType: string;
    jobId?: string;
    status: RutterJobStatus;
    method?: string;
    providerId?: string;
    payload?: Record<string, any>;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
